/**
 * CamelCase、snake_caseの変換
 *
 * 使い方:
 *
 *	import { snake, camel, toCamel, toSnake } from '../Util/SnakeCamelUtil';
 *  ...
 *	console.log(snake( 'snakeCase' ));
 *	// output snake_case
 *	console.log(camel( 'camel_case' ));
 *	// output camelCase
 *  console.log(toCamel(
 *		{
 *			camel_case: 'もじもじ',
 *			hoge_page: 'でで'
 *		}
 *		 ));
 *	// output  Object { camelCase: "もじもじ", hogePage: "でで" }
 */

interface AnyObject {
	[key: string]: any;
}

export const camel = (str: string) =>
	str
		.replace(/_+(.?)/g, (_, p1) => p1.toUpperCase());

export const snake = (str: string) =>
		str
			.replace(/(^[A-Z])/, (_, p1) => p1.toLowerCase())
			.replace(/([A-Z]+)/g, (_, p1) => `_${p1.toLowerCase()}`);

export const camelEx = (str: string) =>
	str
		.toLowerCase()
		.replace(/_+(.?)/g, (_, p1) => p1.toUpperCase());

const detectObject = (obj: any) => {

	if (
		Object.prototype.toString.call(obj) === '[object Object]' ||
		Object.prototype.toString.call(obj) === '[object Array]'
	) {
		return true;
	}
	return false;
};

const propertyNameConverter = ( converterFn: (s: string) => string ) =>
		(data: AnyObject): object => {
			const recursive = (obj: AnyObject): AnyObject => {
				const keys = data ? Object.keys(obj) : [];
				const ret = keys.reduce(
						(accum: object, curr: string) => (
							{
								...accum,
								[converterFn(curr)]: detectObject(obj[curr]) ? recursive(obj[curr]) : obj[curr],
							}
						),
				 {});
				return ret;
				;
		};
		return recursive(data);
	};

export const toSnake = propertyNameConverter(snake);
export const toCamel = propertyNameConverter(camel);
export const toCamelEx = propertyNameConverter(camelEx);

